// AuthContext — Type definitions and useAuth() re-export.
//
// After the DashONE merge, DashmoteAI no longer has its own AuthProvider.
// Auth is provided by DashAIAuthAdapter which bridges DashONE's Redux state.
// This file preserves all type exports so existing imports don't break.

import { useDashAIAuth } from './DashAIAuthAdapter';

// Re-export the adapter's hook as useAuth() — zero changes needed in consuming code.
export const useAuth = useDashAIAuth;

// ---------- Type definitions (unchanged from original DashmoteAI) ----------

export interface GeoscopeRegion {
  key: string;
  name: string;
  markets: string[];
}

export interface CoreBrandContent {
  brand: string;
  subbrand: string | null;
}

export interface CoreBrand {
  name: string;
  content: CoreBrandContent[];
}

export interface Competitor {
  company: string;
  brand: string | null;
}

export interface Weights {
  combo_presence?: number;
  core_availability?: number;
  fixed_combo_presence?: number;
  image_presence?: number;
  market_penetration?: number;
  market_penetration_branded?: number;
  name_accuracy?: number;
  option_combo_presence?: number;
  [key: string]: number | undefined;
}

export interface MarketFormula {
  id_version: string;
  companies: string[];
  core_brands: CoreBrand[];
  competitors: Competitor[];
  weights: Weights;
}

// Not exported: `ClientPermission.pet_formula` below is the only reader, and
// nothing outside this file names the type.
interface PetFormula {
  version_name: string;
  is_active: boolean;
  formula: Record<string, MarketFormula>;
}

export interface ClientPermission {
  is_super_admin: boolean;
  product_scopes: Record<string, string[]> | string[] | null;
  role: string;
  accessible_countries: string[];
  /** The markets onboarding asks about: `accessible_countries`, or the geoscope when that is empty. */
  onboarding_markets?: string[];
  geoscope?: {
    regions: GeoscopeRegion[];
  };
  pet_formula?: PetFormula | null;
}

export interface FirestoreUser {
  userId: string;
  email: string;
  name: string;
  account_type?: string | null;
  application_role: 'user' | 'admin' | 'viewer';
  workspaces: string[];
  /** The workspace the user lands in on a fresh sign-in. A stored preference,
   *  so it does not follow the switcher. Scoping to what the user is looking
   *  at now reads `selectActiveWorkspaceKey` instead: the two differ the
   *  moment they switch. */
  default_id_client: string;
  id_client: Record<string, ClientPermission>;
  dashmote_admin?: boolean;
  createdAt: Date;
  updatedAt: Date;
}
